export default __webpack_public_path__ + "static/media/back.cd9e9981.jpg";